<template>
  <div v-if="show" class="pa-2">
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="checkForm">
      <v-row dense>
        <!-- Nombre de la Familia -->
        <v-col cols="12" class="pb-0">
          <v-text-field v-model.trim="nm" :rules="rules.nombre" label="Nombre del segmento de tarifario"
            placeholder="Ej. Tarifas Estándar / Público" outlined dense required></v-text-field>
        </v-col>


        <!-- Botones de Acción -->
        <v-col cols="12" class="text-right pt-4">
          <v-btn color="red" dark class="mr-2" @click="$emit('toggle', false)">
            Cancelar
          </v-btn>
          <v-btn color="green" dark type="submit">
            Guardar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
export default {
  name: "segmentoReservaForm",
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      valid: true,
      id: "",
      nm: "",


      rules: {
        nombre: [
          (v) => !!v || "El nombre de la familia es obligatorio",
          (v) => (v && v.trim().length >= 2) || "Debe tener al menos 2 caracteres",
        ],

      },
    };
  },

  methods: {
    create() {
      this.$alert.alertConfirm({
        action: "crear",
        obj: "Segmento de tarifa",
        route: "RVA-SegmentosReserva-createSegmentoReserva",
        data: { id: this.id, nm: this.nm },
        onSuccess: () => {
          this.$pgsHelper.writeLog({
            Evento: "CREATE_SEGMENTO_RESERVA",
            Mensaje: `Creacion de segmento de tarifa ` + this.nm,
            reference: { id: this.id, tp: "SEGMENTO_RESERVA", al: "Segmento de tarifa" },
            data: { id: this.id, nm: this.nm },
          });
          this.$emit("reload");
          this.$emit("toggle", false)
        },
      });
    },
    editSegmento() {
      this.$alert.alertConfirm({
        action: "editar",
        obj: "Segmento de tarifa",
        route: "RVA-SegmentosReserva-updateSegmentoReserva",
        data: { id: this.id, nm: this.nm },
        onSuccess: () => {
          this.$pgsHelper.writeLog({
            Evento: "UPDATE_SEGMENTO_RESERVA",
            Mensaje: `Edicion de segmento de tarifa ` + this.nm,
            reference: { id: this.id, tp: "SEGMENTO_RESERVA", al: "Segmento de tarifa" },
            data: { id: this.id, nm: this.nm },
          });
          this.$emit("reload");
          this.$emit("toggle", false)
        },
      });
    },
    resetForm() {
      this.id = "";
      this.nm = "";

      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    checkForm() {
      if (this.$refs.form && this.$refs.form.validate()) {
        if (this.edit) {
          this.editSegmento();
        } else {
          this.create();
        }
      }
    },
  },
  mounted() {
    if (this.edit && this.dataEdit && Object.keys(this.dataEdit).length > 0) {
      this.id = this.dataEdit.id || "";
      this.nm = this.dataEdit.nm || "";

    }
  },
};
</script>

<style scoped>
.color-native-picker {
  width: 40px;
  height: 40px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  padding: 2px;
  cursor: pointer;
  background: #ffffff;
}

.color-dot {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  margin-right: 6px;
  cursor: pointer;
  border: 2px solid #ffffff;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.35);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.color-dot:hover {
  transform: scale(1.15);
}

.color-dot-active {
  transform: scale(1.2);
  box-shadow: 0 0 0 2px #1e293b;
}
</style>
